import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import ProjectCard from './ProjectCard';
import ProjectFilter from './ProjectFilter';

const Featured = ({
  filteredProjects,
  categories,
  technologies,
  selectedCategory,
  selectedTechnology,
  onCategoryChange,
  onTechnologyChange,
  onClearFilters,
  onViewDetails,
}) => {
  return (
    <section id="projects" className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Featured Projects
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Each project represents a unique challenge solved through innovative technology
            and thoughtful architecture decisions.
          </p>
        </div>

        <ProjectFilter
          categories={categories}
          technologies={technologies}
          selectedCategory={selectedCategory}
          selectedTechnology={selectedTechnology}
          onCategoryChange={onCategoryChange}
          onTechnologyChange={onTechnologyChange}
          onClearFilters={onClearFilters}
          projectCount={filteredProjects?.length}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects?.map((project) => (
            <ProjectCard
              key={project?.id}
              project={project}
              onViewDetails={onViewDetails}
            />
          ))}
        </div>

        {filteredProjects?.length === 0 && (
          <div className="text-center py-16">
            <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-foreground mb-2">No Projects Found</h3>
            <p className="text-muted-foreground mb-6">
              Try adjusting your filters to see more projects.
            </p>
            <Button
              variant="outline"
              onClick={onClearFilters}
              iconName="RefreshCw"
              iconPosition="left"
            >
              Clear Filters
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Featured;